import { required } from "common/forms"
import * as Yup from "yup"

const schema = Yup.object({
  select: Yup.string().required(required.default),
  displaySelect: Yup.string().required(required.default),
}).defined()

export const initialFormState: Yup.InferType<typeof schema> = {
  select: "",
  displaySelect: "",
}

export default schema
